import type { ImgHTMLAttributes } from 'react'

import { getAssetSources, type AssetSource } from './sources'

type OptimizedAssetProps = AssetSource &
  Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'srcSet'> & {
    pictureClassName?: string
  }

export const OptimizedAsset = ({
  source,
  avif,
  webp,
  alt,
  pictureClassName,
  loading = 'lazy',
  decoding = 'async',
  ...imageProps
}: OptimizedAssetProps) => (
  <picture className={pictureClassName}>
    {getAssetSources({ source, avif, webp }).map(({ srcSet, type }) => (
      <source key={type} srcSet={srcSet} type={type} />
    ))}
    <img
      {...imageProps}
      src={source}
      alt={alt}
      loading={loading}
      decoding={decoding}
    />
  </picture>
)
